export default __webpack_public_path__ + "static/media/saddle.3d9420b7.png";